import { reads } from 'macro-decorators';
import { waitForProperty } from 'ember-concurrency';
import Service, { service } from '@ember/service';

export default class DevicesAdapterService extends Service {
  @service('twilio.room') twilioRoom;
  @service('chime.meeting-manager') meetingManager;
  @service session;
  @service persistentProperties;

  @reads('session.roomModel.featureThChime') featureThChime;
  @reads('persistentProperties.isVideoPublished') isVideoPublished;
  @reads('persistentProperties.isAudioPublished') isAudioPublished;
  @reads('persistentProperties.selectedVideoQuality') selectedVideoQuality;

  handleVideoDeviceChange(deviceId) {
    this.persistentProperties.setProp('selectedVideoDeviceId', deviceId);

    return this.featureThChime
      ? this.meetingManager.handleVideoInputChange(deviceId, {
          startDevice: this.isVideoPublished,
          videoQuality: this.selectedVideoQuality,
        })
      : this.twilioRoom.handleVideoChange();
  }

  async handleAudioInputDeviceChange(deviceId) {
    this.persistentProperties.setProp('selectedAudioInputDeviceId', deviceId);

    if (this.featureThChime) {
      return this.meetingManager.handleAudioInputChange(deviceId, {
        startDevice: this.isAudioPublished,
      });
    }

    await waitForProperty(this.twilioRoom, 'audioTrack', Boolean);
    return this.twilioRoom.handleAudioInputChange();
  }

  handleAudioOutputDeviceChange(deviceId) {
    this.persistentProperties.setProp('selectedAudioOutputDeviceId', deviceId);

    return this.featureThChime
      ? this.meetingManager.handleAudioOutputChange(deviceId)
      : this.twilioRoom.handleAudioOutputChange();
  }

  handleVideoQualityChange(videoQuality) {
    this.persistentProperties.setProp('selectedVideoQuality', videoQuality);

    if (this.featureThChime) {
      return this.meetingManager.handleVideoInputChange(
        this.meetingManager.selectedVideoInputDevice,
        { startDevice: this.isVideoPublished, videoQuality }
      );
    }
    return this.twilioRoom.handleVideoQualityChange(videoQuality);
  }
}
